import React, { useState, useEffect } from 'react';
import { Controller } from "react-hook-form";
import ModalSkeleton from "../../../../components/Modals/ModalSkeleton";
import CustomButton from "../../../../components/common/Button/CustomButton";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MultiFileInput from "../../../../components/common/FileUpload/MultiFileInput";
import MultiSelectDropdown from "components/common/MultiSelectDropdown";
import SelectOption from "components/common/Select/Select";
import { apiGetRequest } from "../../../../helpers/Requests";
import { URL_FEEDBACK_MANAGERS_LIST,
    URL_FEEDBACK_PARTICIPANTS_LIST,
    URL_FEEDBACK_WORKER_LIST
 } from "store/services/URL";
import {
  FEEDBACK_STATUS_OPTIONS,
} from "../../../../store/constants";
import useCareLabels from "hooks/useCareLabels";
import CareLabelSkeleton from "components/common/CareLabelSkeleton/CareLabelSkeleton";

const AddFeedbackModal = ({
  isOpen,
  closeModal,
  onSubmit,
  register,
  handleSubmit,
  errors,
  control,
  setValue,
  watch,
  isSubmitting,
  isUserGracePeriodOver,
  setFilesData,
  workersList,
  loadingWorkers,
  selectedParticipantForm,
  selectedWorkerForm,
  participantsList,
  managerList,
}) => {
  const { participantLabelPlural, isLoading: isCareLabelsLoading } = useCareLabels();
  // const [managerList, setManagerList] = useState([]);
  const [loadingManagers, setLoadingManagers] = useState(false);
  // const [participantsList, setParticipantsList] = useState([]);

  const [loadingParticipants, setLoadingParticipants] = useState(false);
 
 
  const [statusFilter, setStatusFilter] = useState({ value: 'positive', label: 'Positive' });

  const watchFormData = watch();

  // useEffect(() => {
  //   if (isOpen) {
  //     fetchManagersList();
  //     fetchParticipantsList();

  //     // Set initial status value in form
  //     setValue('status', statusFilter?.value);
  //   }
  // }, [isOpen]);

  // const fetchManagersList = async () => {
  //   setLoadingManagers(true);
  //   try {
  //     const response = await apiGetRequest(URL_FEEDBACK_MANAGERS_LIST);
  //     if (response?.status === 200) {
  //       const formattedManagers = response?.data?.data?.map(manager => ({
  //       id: manager?.user?.id,
  //         value: manager?.user?.email || manager?.user?.id,
  //         label: `${manager?.user?.name}`,
  //       }));
  //       setManagerList(formattedManagers || []);
  //     }
  //   } catch (error) {
  //     setManagerList([]);
  //   } finally {
  //     setLoadingManagers(false);
  //   }
  // };

  // const fetchParticipantsList = async () => {
  //   setLoadingParticipants(true);
  //   try {
  //     const response = await apiGetRequest(URL_FEEDBACK_PARTICIPANTS_LIST);
  //     if (response?.status === 200) {
  //       const formattedParticipants = response?.data?.data?.map((participant) => ({
  //           id: participant?.id,
  //         value: participant?.uuid || '',
  //         label: participant?.first_name + " " + participant?.last_name || '',
  //       }));
  //       setParticipantsList(formattedParticipants || []);
  //     }
  //   } catch (error) {
  //   //   console.error(error);
  //     setParticipantsList([]);
  //   } finally {
  //     setLoadingParticipants(false);
  //   }
  // };



    const modalFooter = () => (
        <CustomButton
        type='submit'
        label='Submit'
        showLoading={isSubmitting}
        isDisabled={isSubmitting || isUserGracePeriodOver}
        clickHandler={() => {
            if (isUserGracePeriodOver) return;
            const buttonRef = document.getElementById("allFeedBack");
            if (buttonRef) buttonRef.click();
        }}
        />
    );

  return (
    <ModalSkeleton
      isOpen={isOpen}
      title='Add Feedback'
      cssClass='w-[50%]'
      closeModal={closeModal}
      modalFooter={modalFooter()}
    >
      <div>
        <div className='flex flex-col'>
          <p className='text-sm text-gray-500 mb-3'>
            Please add your Feedback here
          </p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className=''>
          <div className='grid grid-cols-2 gap-x-4'>
            {/* <div className='mt-1 col-span-3 sm:col-span-1'>
              <label className='did-floating-label'>Name</label>
              <input
                {...register("name", { required: true })}
                className='did-floating-input'
                type='text'
              />
              {errors?.name?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div> */}

             <div className='mt-1 col-span-2 sm:col-span-1'>
              <label className='did-floating-label'>
                {isCareLabelsLoading ? (
                  <CareLabelSkeleton width="w-28" height="h-3.5" />
                ) : (
                  participantLabelPlural
                )}
              </label>
              <MultiSelectDropdown
                showIcon
                data={participantsList}
                cssClass='z-30'
                name='participants'
                register={register}
                setValue={setValue}
                control={control}
                watch={watch}
                isDisabled={loadingParticipants || isCareLabelsLoading}
                placeholder={
                  isCareLabelsLoading
                    ? "Select..."
                    : loadingParticipants
                    ? `Loading ${participantLabelPlural.toLowerCase()}...`
                    : `Select ${participantLabelPlural}`
                }
              />
            </div>

            <div className='mt-1 col-span-2 sm:col-span-1'>
              <label className='did-floating-label'>Workers</label>
              <MultiSelectDropdown
                showIcon
                data={workersList}
                cssClass='z-30'
                name='workers'
                register={register}
                setValue={setValue}
                control={control}
                watch={watch}
                isDisabled={loadingParticipants}
              />
            </div>

            <div className='mt-1 col-span-2 sm:col-span-1'>
              <label className='did-floating-label'>Mention Manager</label>
              <MultiSelectDropdown
                showIcon
                data={managerList}
                cssClass='z-30'
                name='email'
                register={register}
                setValue={setValue}
                control={control}
                watch={watch}
                isDisabled={loadingManagers}
                placeholder={loadingManagers ? "Loading managers..." : "Select Managers"}
              />
              {errors?.email?.type === "required" && (
                <span className='text-sm text-red-500'>
                  At least one manager must be selected!
                </span>
              )}
            </div>

            <div className='mt-1 col-span-2 sm:col-span-1'>
              <label className='did-floating-label'>Type 
                   <span className='text-red-500'>*</span>
              </label>

<Controller
              name='status'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectOption
                  cssClass='mt-1'
                  isSearch={false}
                  data={FEEDBACK_STATUS_OPTIONS}
                  selectedOption={field.value}
                  handleChange={(e) => {
                
                    setStatusFilter(e);
                    field.onChange(e);
                  }}
                  placeholder="Select Status"
                  className='w-full'
                />
              )}
            />
{errors?.status?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
              {/* <SelectOption
                data={FEEDBACK_STATUS_OPTIONS}
                selectedOption={statusFilter}
                setSelectedOption={(option) => {
                  setStatusFilter(option);
                  setValue('status', option?.value);
                }}
                placeholder="All Status"
                className='w-full'
              /> */}
            </div>

            <div className='mt-1 col-span-3 sm:col-span-1'>
              <label className='did-floating-label'>Date 
                <span className='text-red-500'>*</span>
              </label>
              <Controller
                name='date'
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState }) => (
                  <DateRangeWithRegister
                    isSingleDate
                    field={field}
                    fieldState={fieldState}
                    placeholder='Select  Date'
                    showCalendarIcon
                  />
                )}
              />
              {errors?.date?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div>

            <div className='mt-1 col-span-2 sm:col-span-1'>
              <label className='did-floating-label'>Subject
                <span className='text-red-500'>*</span>
              </label>
              <input
                {...register("subject", { required: true })}
                className='did-floating-input'
                type='text'
              />
              {errors?.subject?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div>


            <div className='mt-1 col-span-2'>
              <label className='did-floating-label'>Details
                <span className='text-red-500'>*</span>
              </label>
              <Controller
                name="details"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <CKEditor
                    editor={ClassicEditor}
                    data={field.value || ''}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      field.onChange(data);
                    }}
                    config={{
                      placeholder: "Enter feedback details here...",
                    }}
                  />
                )}
              />
              {errors?.details?.type === "required" && (
                <span className='text-sm text-red-500'>
                  This field is required!
                </span>
              )}
            </div>

            <div className='mt-4 col-span-2'>
              <label className='did-floating-label'>
                Attachments
              </label>
              <MultiFileInput
                filenameLimit={150}
                type='feedback'
                handleFile={(files) => setValue("attachments", files)}
                size={5}
                files={watchFormData?.attachments}
                handleDelete={(remainingFiles) => setValue("attachments", remainingFiles)}
                showDragAndDrop={false}
                isHardClearAllStates={isSubmitting === true}
                setFilesData={setFilesData}
                setIsSubmitting={() => {}}
                isFileUploadToS3={true}
              />
            </div>
          </div>
          <button
            type='submit'
            className='hidden sr-only'
            id='allFeedBack'
          />
        </form>
      </div>
    </ModalSkeleton>
  );
};

export default AddFeedbackModal;
